import React from 'react';
import toastImage from '../assets/toast.png';
import beerIcon from "../assets/page_logo.png";
import { useNavigate } from 'react-router-dom';

function ContactPage() {
  const navigate = useNavigate();

  return (
    <div style={{ backgroundColor: "#fff" }}>
      {/* AppBar */}
      <div
        style={{
          backgroundColor: "#F9F4EA",
          padding: "20px",
        }}
      >
        <div
          style={{
            maxWidth: "1000px",
            margin: "0 auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          {/* Logo */}
          <div
            onClick={() => navigate("/")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              cursor: "pointer", // shows a hand cursor
              userSelect: "none", // optional: prevents text highlight
              paddingTop: "5px",
              marginLeft: "-5px", // Adjusted for better alignment
            }}
          >
            <img src={beerIcon} alt="beer icon" style={{ width: "150px" }} />
          </div>

          {/* Contact Button */}
          <div
            style={{
              display: "flex",
              // Wrap so two 170px pills can stack, and drop the 40px right padding: on a
              // 390px screen it pushed this row 40px past the viewport, which was the whole
              // of /contact's horizontal scroll. AC-MOBILE-F1.
              flexWrap: "wrap",
              justifyContent: "flex-start",
              gap: "10px",
            }}
          >
            <button
              style={{
                ...topHeaderButtonStyle,
                backgroundColor: "#DE810E",
                color: "white",
              }}
            >
              Contact Us
            </button>
            <button
              onClick={() => navigate("/admin-login")}
              style={{
                ...topHeaderButtonStyle,
                backgroundColor: "white",
                color: "#DE810E",
              }}
            >
              Partner Login
            </button>
          </div>
        </div>
      </div>

      {/* Top Text Section */}
      <div
        style={{
          backgroundColor: "#F9F4EA",
          padding: "0px 20px 130px 20px",
          textAlign: "center",
        }}
      >
        <h4
          style={{
            color: "#000",
            margin: "0px",
            fontSize: "clamp(1.6rem, 7vw, 2.5rem)",
            fontWeight: "bold",
          }}
        >
          Have one on me
        </h4>
        <h2
          style={{
            fontSize: "1rem",
            color: "#555",
            maxWidth: "700px",
            margin: "0 auto",
            fontWeight: "normal",
            textAlign: "center",
          }}
        >
          We’re here to help — drop us a note and we’ll get back to you soon.
        </h2>
      </div>

      {/* Main Content */}
      <div style={{ padding: "40px 20px" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "40px",
            maxWidth: "1000px",
            margin: "0 auto",
          }}
        >
          {/* Image */}
          <div style={{ flex: "1 1 300px", minWidth: "240px" }}>
            <img
              src={toastImage}
              alt="Toast"
              style={{
                marginLeft: "-10px",
                width: "100%",
                maxWidth: "430px",
                display: "block",
                margin: "0 auto",
              }}
            />
          </div>

          {/* Form Section */}
          <div style={{ flex: "1 1 400px", minWidth: "260px" }}>
            <div style={cardStyle}>
              <form
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch",
                  gap: "12px",
                }}
              >
                {/* Name Row */}
                <div style={nameRowStyle}>
                  <input
                    type="text"
                    placeholder="First Name"
                    required
                    style={halfInputFixed}
                  />
                  <input
                    type="text"
                    placeholder="Last Name"
                    required
                    style={halfInputFixed}
                  />
                </div>

                <input
                  type="tel"
                  placeholder="Phone Number"
                  required
                  style={shortInputStyle}
                />
                <input
                  type="email"
                  placeholder="Email Address"
                  required
                  style={shortInputStyle}
                />
                <textarea
                  placeholder="Message"
                  rows="5"
                  required
                  style={{
                    ...shortInputStyle,
                    resize: "vertical",
                    // Justified text in a narrow textarea opens rivers of whitespace between
                    // words as the visitor types. AC-MOBILE-F5.
                    textAlign: "left",
                  }}
                />

                <button
                  type="submit"
                  style={{ ...buttonStyle, alignSelf: "flex-start" }}
                >
                  Send Message
                </button>

                <p
                  style={{
                    fontSize: "0.9rem",
                    color: "#777",
                    marginTop: "10px",
                    // Not justify: this is a single short line, so justification stretches
                    // five words across the full column width on a phone. AC-MOBILE-F5.
                    textAlign: "left",
                  }}
                >
                  Or email us directly at{" "}
                  <a
                    href="mailto:contact@myhoom.com"
                    style={{ color: "#ff8c00", fontWeight: "bold" }}
                  >
                    contact@myhoom.com
                  </a>
                </p>
              </form>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              minWidth: "260px",
            }}
          >
            <p
              style={{
                fontSize: "clamp(1.6rem, 7vw, 2.5rem)",
                fontWeight: "bold",
                color: "#303030",
                textAlign: "center",
              }}
            >
              Want to be a partner?
            </p>
            <button
              onClick={() => navigate("/admin-signup")}
              style={{
                backgroundColor: "white",
                color: "#DE810E",
                border: "1px solid #DE810E",
                borderRadius: "30px",
                padding: "12px 24px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              Sign Up Here
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Styles
const nameRowStyle = {
  display: "flex",
  gap: "16px",
  width: "100%",
};

const halfInputFixed = {
  width: "50%",
  padding: "12px 16px",
  border: "1px solid #ccc",
  borderRadius: "8px",
  fontSize: "1rem",
  boxSizing: "border-box",
};

const shortInputStyle = {
  width: "100%",
  padding: "12px 16px",
  border: "1px solid #ccc",
  borderRadius: "8px",
  fontSize: "1rem",
  boxSizing: "border-box",
};

const buttonStyle = {
  marginTop: "20px",
  backgroundColor: "#DE810E",
  color: "white",
  border: "none",
  borderRadius: "30px",
  padding: "15px 25px",
  cursor: "pointer",
  fontWeight: "bold",
  width: "auto",
  maxWidth: "350px",
};

const cardStyle = {
  backgroundColor: "#fefefe",
  padding: "10px",
  borderRadius: "16px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
  width: "100%",
  boxSizing: "border-box",
};

const topHeaderButtonStyle = {
  border: "none",
  borderRadius: "30px",
  width: "min(170px, 46vw)",
  height: "46px",
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: "14px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
};

export default ContactPage;
